<div class="aztec-process-info">
  <div class="aztec-process-info__image">
    <img class="aztec-process-info__image__background"
         [src]="phoneImageSrc" alt="">
    <app-qr-code class="aztec-process-info__image__qr-code"
                 [value]="qrCodeUrl">
    </app-qr-code>
  </div>

  <div class="aztec-process-info__content">

    <div class="aztec-process-info__arrow">
      <img src="./assets/images/aztec-info-arrow.svg" alt="">
    </div>
    <div class="aztec-process-info__title">
      {{ 'AZTEC_PROCESS_INFO.title' | translate }}
    </div>

    <ol class="aztec-process-info__steps">
      <li class="aztec-process-info__step"
          [innerHTML]="step | translate | safeHtml"
          *ngFor="let step of steps">
      </li>
    </ol>
  </div>
</div>
